import apiClient from "@services/api/apiClient.jsx";

const roleApi = {
    // 모든 역할 목록 가져오기
    getRoles: async () => {
        try {
            const response = await apiClient.get("/infra/roles");
            return response.data;
        } catch (error) {
            console.error("역할 목록 가져오기 실패:", error);
            throw error;
        }
    },
    
    // 특정 역할 타입으로 필터링된 역할 목록 가져오기
    getRolesByType: async (roleType) => {
        try {
            const response = await apiClient.get(`/infra/roles/type/${roleType}`);
            return response.data;
        } catch (error) {
            console.error(`${roleType} 역할 목록 가져오기 실패:`, error);
            throw error;
        }
    },
    
    // 페이징 처리된 역할 그룹 목록 가져오기
    getRoleGroups: async (page = 0, size = 10, sort = "createdAt,desc") => {
        try {
            const response = await apiClient.get("/infra/roles/groups", {
                params: { page, size, sort }
            });
            return response.data;
        } catch (error) {
            console.error("역할 그룹 목록 가져오기 실패:", error);
            throw error;
        }
    },
    
    // 역할 그룹 추가
    createRoleGroup: async (groupData) => {
        try {
            const response = await apiClient.post("/infra/roles/groups", groupData);
            return response.data;
        } catch (error) {
            console.error("역할 그룹 추가 실패:", error);
            throw error;
        }
    },
    
    // 역할 그룹 수정
    updateRoleGroup: async (groupId, groupData) => {
        try {
            const response = await apiClient.put(`/infra/roles/groups/${groupId}`, groupData);
            return response.data;
        } catch (error) {
            console.error("역할 그룹 수정 실패:", error);
            throw error;
        }
    },
    
    // 역할 그룹 삭제
    deleteRoleGroup: async (groupId) => {
        try {
            const response = await apiClient.delete(`/infra/roles/groups/${groupId}`);
            return response.data;
        } catch (error) {
            console.error("역할 그룹 삭제 실패:", error);
            throw error;
        }
    },
    
    // 역할 그룹명 중복 확인
    checkGroupNameDuplicate: async (groupName) => {
        try {
            const response = await apiClient.get(`/infra/roles/groups/check-name`, {
                params: { name: groupName }
            });
            return response.data;
        } catch (error) {
            console.error("역할 그룹명 중복 확인 실패:", error);
            throw error;
        }
    },
    
    // 사용 가능한 모든 권한 목록 가져오기
    getAllPermissions: async () => {
        try {
            const response = await apiClient.get("/infra/permissions");
            return response.data;
        } catch (error) {
            console.error("권한 목록 가져오기 실패:", error);
            throw error;
        }
    }
};

export default roleApi;